import { mutateApi, queryApi } from "src/utils/api/ApiMethods"

export const createAccountSession = ({ stripeAccountId }) => {
  return mutateApi({
    url: "/stripe/account_sessions/account_onboarding",
    method: "POST",
    data: { stripe_account_id: stripeAccountId },
  })
}

export const createAccountSettingsSession = ({ stripeAccountId }) => {
  return mutateApi({
    url: "/stripe/account_sessions/account_settings",
    method: "POST",
    data: { stripe_account_id: stripeAccountId },
  })
}

export const queryOnboardingCompletion = ({ stripeAccountId }) => {
  return queryApi(
    `/stripe/account_sessions/onboarding_completion?stripe_account_id=${stripeAccountId}`
  )
}
